<template>
  <div class="app-inner">
    <!-- <el-form :inline="true">
      <el-form-item label="考勤时段">
       <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form> -->
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane>
        <!-- <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane> -->
        <el-tab-pane label="已审批" name="queryApproval">
          <div slot="label">
            已审批
                <!-- <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge> -->
          </div>
        </el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #operate={row}>
        <el-button :key="row.id" @click="examine(row.id)" class="tableBtn" type="text" size="small" v-if="activeName == 'queryMyAudit'">审核</el-button>
        <el-button :key="row.id" @click="detail(row.id)" class="tableBtn" type="text" size="small" v-if="activeName == 'queryApproval'">详情</el-button>
      </template>
    </table-list>
    <abnormal-application ref="AbnormalApplication" @query="query"/>
  </div>
</template>

<script>
import AbnormalApplication from '../attendanceDetails/abnormalApplication.vue'
import TableList from '@/components/TableList.vue'
import { queryApply, listApplyAudited } from '@/api/compAttendance.js'
export default {
  data () {
    return {
      // time: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableData: [],
      columnDefs: [
        { label: '申请编号', prop: 'eventId' },
        { label: '申请人', prop: 'applyUser', minWidth: 100 },
        { label: '申请时间', prop: 'createTime', minWidth: 180 },
        { label: '操作', prop: 'operate', width: 100 },
      ],
      activeName: 'queryMyAudit'
    }
  },
  components: {
    TableList,
    AbnormalApplication
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let queryIng = this.activeName === 'queryMyAudit' ? queryApply : listApplyAudited
      queryIng({
        pageNum: this.page,
        pageSize: this.pageSize
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    examine (id) {
      this.$refs.AbnormalApplication.showDialog('examine', id)
      this.$refs.AbnormalApplication.actionType = 'update'
    },
    detail (id) {
      this.$refs.AbnormalApplication.showDialog('details', id)
    }
  },
  mounted () {
    this.query()
  }
}
</script>
